export default {
    data() {
        return {
            currencyList: [
                { label: "PLN", value: 0 },
                { label: "EUR", value: 1 },
                { label: "USD", value: 2 },
            ],
            euro: 1,
            pln: 0,
            usd: 2
        }
    },

};
